import * as CryptoJS from 'crypto-js';
import { keyCloakConfig } from '../models/si-keycloak-config.model';

export class keyCloakUtilis {

     public static generateRandomString(length: number): string {
        let result = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const charactersLength = characters.length;
        for (let i = 0; i < length; i++) {
          result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
      }

      private static generateCryptoHash(code : string) : string {
        const codeVerifierHash = CryptoJS.SHA256(code).toString(CryptoJS.enc.Base64);
        return codeVerifierHash.replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
      }

      public static getKeyCloakLoginUrl(keyCloakConfigObj: keyCloakConfig, state: string, codeVerifier: string) : string {

        const params = [
          'response_type=' + keyCloakConfigObj.getAuthResponseType(),
          'state=' + state,
          'client_id=' + keyCloakConfigObj.getAuthClientId(),
          'scope=' + keyCloakConfigObj.getAuthScope(),
          'code_challenge=' + this.generateCryptoHash(codeVerifier),
          'code_challenge_method=' + keyCloakConfigObj.getAuthCodeChallengeMethod(),
          'redirect_uri=' + encodeURIComponent(keyCloakConfigObj.getAuthRedirectUrl()),
        ];

        return keyCloakConfigObj.getAuthUrl() + '?' + params.join('&');

      }

      public static getKeyCloakLogoutUrl(keycloakLogoutUrl: string, idToken : string, postLogoutUrl : string, clientId: string) : string {

        const params = [
          'client_id=' + clientId,
          'post_logout_redirect_uri=' + postLogoutUrl
         // 'id_token_hint=' + idToken
        ];

        return keycloakLogoutUrl + '?' + params.join('&');;
      }

}